import { BasePlugin, Events, Errors } from 'xgplayer'
import { EVENT } from 'xgplayer-streaming-shared'
import { Hls } from './hls'
import PluginExtension from './plugin-extension'

export class HlsPlugin extends BasePlugin {
  static Hls = Hls

  hls = null

  pluginExtension = null

  static get pluginName () {
    return 'hls'
  }

  get core () {
    return this.hls
  }

  get version () {
    return this.hls?.version
  }

  get softDecode () {
    return this.player?.config?.mediaType === 'live-video'
  }

  beforePlayerInit () {
    const config = this.player.config
    if (this.hls) this.hls.destroy()
    this.player.switchURL = (...args) => this.hls.switchURL(...args)

    const hlsOpts = config.hls || {}
    if (hlsOpts.disconnectTime == null) hlsOpts.disconnectTime = 0

    this.hls = new Hls({
      softDecode: this.softDecode,
      isLive: config.isLive,
      media: this.player.video,
      startTime: config.startTime,
      ...hlsOpts
    })

    if (this.softDecode) {
      BasePlugin.defineGetterOrSetter(this.player, {
        __url: {
          get: () => this.hls?.media?.src,
          configurable: true
        }
      })
    }

    if (this.softDecode) {
      this.pluginExtension = new PluginExtension({
        isLive: config.isLive,
        media: this.player.video,
        ...config.hls
      }, this)
      this.player.forceDegradeToVideo = (...args) => this.pluginExtension?.forceDegradeToVideo(...args)
    }

    this.player?.useHooks('replay', () => this.hls?.replay())

    this.on(Events.URL_CHANGE, this._onSwitchURL)
    this.on(Events.DEFINITION_CHANGE, this._onDefinitionChange)
    this.on(Events.DESTROY, this.destroy)

    this._transError()
    this._transCoreEvent(EVENT.TTFB)
    this._transCoreEvent(EVENT.LOAD_START)
    this._transCoreEvent(EVENT.LOAD_RESPONSE_HEADERS)
    this._transCoreEvent(EVENT.LOAD_COMPLETE)
    this._transCoreEvent(EVENT.LOAD_RETRY)
    this._transCoreEvent(EVENT.KEYFRAME)
    this._transCoreEvent(EVENT.METADATA_PARSED)
    this._transCoreEvent(EVENT.SEI)
    this._transCoreEvent(EVENT.SPEED)
    this._transCoreEvent(EVENT.STREAM_EXCEPTION)
    this._transCoreEvent(EVENT.SWITCH_URL_SUCCESS)
    this._transCoreEvent(EVENT.SWITCH_URL_FAILED)

    this.hls.load(config.url)
  }

  destroy = () => {
    if (this.hls) {
      this.hls.destroy()
      this.hls = null
    }

    this.pluginExtension?.destroy()
    this.pluginExtension = null
  }

  static isSupported (softDecode) {
    return Hls.isSupported(softDecode)
  }

  _onSwitchURL = (url) => {
    if (this.hls) this.hls.switchURL(url)
  }

  _onDefinitionChange = ({ to }) => {
    if (this.hls) this.hls.switchURL(to)
  }

  _transError () {
    this.hls.on(EVENT.ERROR, (err) => {
      if (this.player) {
        this.player.emit(Events.ERROR, new Errors(this.player, err))
      }
    })
  }

  _transCoreEvent (eventName) {
    this.hls.on(eventName, (e) => {
      if (this.player) {
        this.player.emit('core_event', {
          ...e,
          eventName
        })
      }
    })
  }
}
